import React from 'react';
import './TrainingRow.css';

const formatTime = (dateTime) => {
    const date = new Date(dateTime);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const TrainingRow = ({ training, expandedTraining, toggleExpand, openForm }) => {
    const handleRowClick = () => {
        toggleExpand(training.id);
    };

    const handleRegisterClick = (e) => {
        e.stopPropagation(); // Prevent row click when clicking Register button
        openForm(training);
    };

    return (
        <div>
            <div className="training-row" onClick={handleRowClick}>
                <p>{training.summary}</p>
                <p>{new Date(training.start.dateTime).toDateString()}</p>
                <p>{`${formatTime(training.start.dateTime)} - ${formatTime(training.end.dateTime)}`}</p>
                <p><strong>Amount:</strong> {training.amount} PLN</p>
                <div className="register-section">
                    <button onClick={handleRegisterClick}>Register</button>
                    <p className="attendees-count">Registered: {Math.max(0, training.number_of_attendees)}</p>
                </div>
                <span className={`arrow ${expandedTraining === training.id ? 'expanded' : ''}`}>▼</span>
            </div>
            <div className={`training-description ${expandedTraining === training.id ? 'expanded' : ''}`}>
                {expandedTraining === training.id && training.description.split('\n').map((line, index) => (
                    <p key={index} style={{ textAlign: 'left' }}>{line}</p>
                ))}
            </div>
        </div>
    );
};

export default TrainingRow;
